import { useTranslation } from 'react-i18next'
import { Badge } from '@/components/ui/badge'
import { SEVERITY_META } from '@/features/schema/severity'
import type { ConceptDefinition, ValidationFinding } from '@/services/api/schemas'

export function FindingRow({
  finding,
  concept,
}: {
  finding: ValidationFinding
  concept: ConceptDefinition | undefined
}) {
  const { t } = useTranslation()
  const meta = SEVERITY_META[finding.severity]
  const Icon = meta.Icon
  return (
    <div className={`rounded-md border p-3 text-sm ${meta.rowClass}`}>
      <div className="flex items-start gap-3">
        <Icon className="mt-0.5 h-4 w-4 shrink-0" />
        <div className="flex-1 space-y-1">
          <div className="flex flex-wrap items-center gap-2">
            <Badge className={meta.badgeClass}>{t(meta.labelKey)}</Badge>
            <span className="font-mono text-xs">{finding.concept_id}</span>
            <span className="text-muted-foreground font-mono text-xs">{finding.location}</span>
          </div>
          <div>{finding.message}</div>
          {concept?.effect.outcome && (
            <div className="text-muted-foreground text-xs">
              <span className="font-medium">{t('schemaAgent.editor.findings.effect')} — </span>
              {concept.effect.outcome}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
